import { useState } from "react";
import api from "../lib/api";
import { ArrowRight, FileText } from "lucide-react";
import { toast } from "sonner";

const PRACTICE_AREAS = [
  ["criminal-defense", "Federal Criminal Defense"],
  ["section-1983", "§1983 Civil Rights"],
  ["appellate", "Federal Appellate"],
  ["first-amendment", "First Amendment"],
  ["prosecutor-misconduct", "Prosecutor Misconduct"],
  ["official-misconduct", "Official Misconduct"],
];

export default function MotionsSubmit() {
  const [form, setForm] = useState({
    submitter_name: "", submitter_email: "", submitter_firm: "",
    title: "", case_type: "", practice_area: "criminal-defense", court: "",
    authorities: "", motion_text: "", why_it_matters: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/defenders/motions/submit", form);
      setSubmitted(true);
      toast.success("Motion submitted to the Founder.");
    } catch (err) { toast.error(err.response?.data?.detail || "Submission failed."); }
  };

  return (
    <div className="max-w-4xl mx-auto px-6 lg:px-10 py-16" data-testid="motions-submit">
      <div className="mono text-[11px] tracking-[0.22em] uppercase text-[#D97706]">// Submit a Motion</div>
      <h1 className="display-black text-4xl lg:text-5xl uppercase text-[#064E3B] mt-3 tracking-tighter">Get on the archive.</h1>
      <p className="text-gray-700 mt-3 max-w-2xl">
        Anonymise the parties. Keep the law. The Founder reviews every submission personally. Selected motions are published with your firm attribution.
      </p>

      {submitted ? (
        <div className="mt-10 border border-[#064E3B] bg-gray-50 p-10" data-testid="motions-submit-success">
          <FileText className="w-10 h-10 text-[#D97706]" />
          <h2 className="display-black text-2xl uppercase text-[#064E3B] mt-4">Submitted to the Founder.</h2>
          <p className="text-gray-800 mt-3">If your motion is selected for publication, you'll receive an email with the preview link and your credit line. We publish weekly.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5 border border-gray-300 p-7" data-testid="motions-submit-form">
          <input className="input-federal" required placeholder="Your name" value={form.submitter_name} onChange={e => setForm({...form, submitter_name: e.target.value})} data-testid="ms-name" />
          <input className="input-federal" required type="email" placeholder="Email" value={form.submitter_email} onChange={e => setForm({...form, submitter_email: e.target.value})} data-testid="ms-email" />
          <input className="input-federal md:col-span-2" placeholder="Firm (optional)" value={form.submitter_firm} onChange={e => setForm({...form, submitter_firm: e.target.value})} data-testid="ms-firm" />

          <input className="input-federal md:col-span-2" required placeholder="Motion title" value={form.title} onChange={e => setForm({...form, title: e.target.value})} data-testid="ms-title" />
          <input className="input-federal" required placeholder="Case type (e.g. Federal Drug Conspiracy)" value={form.case_type} onChange={e => setForm({...form, case_type: e.target.value})} data-testid="ms-case-type" />
          <select className="input-federal" value={form.practice_area} onChange={e => setForm({...form, practice_area: e.target.value})} data-testid="ms-practice-area">
            {PRACTICE_AREAS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
          </select>
          <input className="input-federal md:col-span-2" required placeholder="Court (e.g. U.S. District Court · 10th Circuit)" value={form.court} onChange={e => setForm({...form, court: e.target.value})} data-testid="ms-court" />

          <input className="input-federal md:col-span-2" required placeholder="Key authorities cited (comma-separated)" value={form.authorities} onChange={e => setForm({...form, authorities: e.target.value})} data-testid="ms-authorities" />

          <textarea className="input-federal md:col-span-2" rows={14} required placeholder="The motion text — anonymise names, dates, locations" value={form.motion_text} onChange={e => setForm({...form, motion_text: e.target.value})} data-testid="ms-text" />

          <textarea className="input-federal md:col-span-2" rows={3} required placeholder="Why it matters (one paragraph — the doctrine, the leverage, the lesson)" value={form.why_it_matters} onChange={e => setForm({...form, why_it_matters: e.target.value})} data-testid="ms-why" />

          <button type="submit" className="btn-signal md:col-span-2 justify-center" data-testid="ms-submit">Send to Founder <ArrowRight className="w-4 h-4" /></button>
        </form>
      )}
    </div>
  );
}
